export default {
	accounts: {
		name: 'Account | Accounts',
		id: 'Account-ID',
		journal: '@:entity.journal.name',
		approve_all_journals: 'Approve All Journals',
		reject_all_journals: 'Reject All Journals',
		show_document: 'Show Document',
		hide_document: 'Hide Document',
		default: 'Default',
		reviews: 'Reviews',
		reviewed: 'reviewed',
		updated: 'updated',
		assign_reviewer: 'Assign Reviewer',
		select_people_to_continue: 'Please select people to continue',
		read: 'Read',
		write: 'Write',
		accountingYear: 'Fiscal Year',
		unit: 'Unit',
		deeplink: {
			buildingAccountNotFound:
				'The linked account could not be found in this property. It may have been removed.',
			accountNotFound: 'The linked account could not be found in this review document. It may have been removed.',
			loadingAccount: 'One moment, we are taking you to the linked account.',
			loadingJournal: 'One moment, we are taking you to the linked journal entry.',
			journalNotFound: 'The linked journal entry could not be found in this account. It may have been removed.',
			fromNotification: 'From your notification',
			contraAccountNotInReview:
				'The contra account is not part of this review document. You will find it in the property accounting.',
			jumpToContraAccount: 'Jump to contra account',
			returnFromJournalHint: 'You jumped here from a journal entry.',
			returnFromJournal: 'Back to journal entry',
			returnFromInvoiceHint: 'You jumped here from an invoice.',
			returnFromInvoice: 'Back to invoice',
		},
	},
}
